(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["backorder-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const expireRemoteStock = () => {
      const now = Math.floor(Date.now() / 1000);
      document.querySelectorAll('[data-remote-valid-until]').forEach((element) => {
        if (Number(element.dataset.remoteValidUntil) <= now) {
          element.textContent = element.dataset.remoteUnknown;
          element.removeAttribute('data-remote-valid-until');
        }
      });
    };
    expireRemoteStock();
    document.addEventListener('DOMContentLoaded', expireRemoteStock, { once: true });
    new MutationObserver(expireRemoteStock).observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(expireRemoteStock, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
